import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { initInvolved } from "../schemas";
import { useConstants } from "../../Main/useConstants";

// Hook para controlar la parte de involucrados del formulario y la de la investigacion correctamente
export const useInvolveds = (investigation, reportDetail) => {

  const { involveds: { statusOpts } } = useConstants();

  const [involvedsInInvestigation, setInvolvedsInInvestigation] = useState(null);
  const [involvedsInReport, setInvolvedsInReport] = useState(null);

  // Encontrar involucrados en la invstigacion
  useEffect(() => {
    if (investigation?.involved) {
      setInvolvedsInInvestigation(() => ({
        victim: investigation?.involved.victim ?? [],
        witness: investigation?.involved.witness ?? [],
        offender: investigation?.involved.offender ?? [],
        accomplice: investigation?.involved.accomplice ?? [],
      }))
    } else {
      setInvolvedsInInvestigation(() => _.cloneDeep(initInvolved));
    }
  }, [investigation?.involved]);

  // Encontrar involucrados en el reprote
  useEffect(() => {

    let formInvolved = null;
    let found = false;
    let found2 = false;
    let sensitive = false;

    // BUSCAR SI HAY CAMPO DE INVOLUCRADOS EN EL REPORTE Y SI ES SENSIBLE
    for (let item2 of reportDetail?.form) { 
      for (let subItem2 of item2.form["json-schema"]) {
        if (subItem2.key === "involucrados") {
          found2 = true;
          sensitive = subItem2.sensitive;
          break;
        }
      }
      if (found2) break;
    }

    // SI NO ES SENSIBLE HAY MOSTRAR LOS INVOLUCRADOS
    if (sensitive == false) {
      for (let item of reportDetail?.stepers) {
        for (let subItem of item.form) {
          if (subItem.key === "involucrados") {
            formInvolved = subItem.value
            // setInvolvedsInReport(subItem.value);
            found = true;
            break;
          }
        }
        if (found) break;
      }
    }

    // DAR FORMATO A LOS INVOLUCRADOS QUE VIENEN DEL REPORTE Y PONERLOS EN LE ESTADO
    if (Array.isArray(formInvolved)) {
      // Inicializamos el resultado con 'involved' si existe, o un nuevo objeto si no
      const parsedInvolveds = _.cloneDeep(initInvolved);
      // Iteramos sobre 'involucrados' para combinar datos
      formInvolved.forEach((person) => {
        const { type, name, occupation } = person;
        // Vemos si tiene modificaciones en comparacion al reporte
        const modifiedIndex = involvedsInInvestigation?.[type]?.findIndex(item=>item.rType === type && item.rName === name && item.rOccupation === occupation);
        // Si tiene modificaciones las tomamos
        if (modifiedIndex >= 0) {
          const findedInvolved = involvedsInInvestigation[type][modifiedIndex];
          parsedInvolveds[findedInvolved.kind].push(findedInvolved);
        } else { // Si no tiene modificaciones tomamos el involucrado como viene en el reporte
          parsedInvolveds[type].push({
            rol: type,
            kind: type,
            name,
            collaborator: "",
            additional: "", // # empleado
            area: "", // area o departamento
            indicated: "complainant",
            confirm: statusOpts[0].value,
            details: '',
            relationship: occupation,
            rName: name,
            rType: type,
            rOccupation: occupation,
            validated: false,
            added: true
          });
        }
      });
      setInvolvedsInReport(parsedInvolveds);
    }
  }, [reportDetail, involvedsInInvestigation]);

  // SI EXISTEN INVOLUCRADOS YA SEA EN EL REPORTE O INVESTIGACION EL VALOR ES TRUE
  const haveInvolveds = useMemo(() => {
    if (!involvedsInInvestigation && !involvedsInReport) return false;
    const fromInvestigation = Object.keys(involvedsInInvestigation ?? {}).length > 0 && Object.values(involvedsInInvestigation).some(type =>  type?.length > 0 );
    const fromReport = Object.keys(involvedsInReport ?? {}).length > 0 && Object.values(involvedsInReport).some(type =>  type?.length > 0 );
    return (fromInvestigation || fromReport)
  }, [involvedsInInvestigation, involvedsInReport])
  
  return {
    involvedsInInvestigation,
    involvedsInReport,
    haveInvolveds,
  }
}